export async function index() {
    const data = await this.$adminRepositories.projects.getProjectNeedPayment();
    return data;
}
  